/* src/app/global/components/global-settings-changelanguage/global-settings-changelanguage.component.scss */
:host .cw-login-error + .cw-button-wrapper {
  justify-content: center;
}
h3 {
  margin-bottom: 10px;
}
/*# sourceMappingURL=global-settings-changelanguage.component.css.map */
